import { useState } from 'react'

import { ProjectForSelectFragment } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ProjectSelector } from 'modules/project_management/components/selectors/ProjectSelector'

interface ProjectFilterProps {
  onChangeFilter: (filterValue: Record<string, string[]>) => void
}

const ProjectFilter = ({ onChangeFilter }: ProjectFilterProps) => {
  const [selectedProjects, setSelectedProjects] = useState<ProjectForSelectFragment[]>([])

  const onChange = (projects: ProjectForSelectFragment[]) => {
    track(trackingEvents.projectManagement.schedule.clickOnProjectsFilter, {})
    setSelectedProjects(projects)
    const filterValue = { projectIds: projects.map((project) => project.id) }
    onChangeFilter(filterValue)
  }

  return (
    <Filter.EntitySelector
      label={i18n.t('project_management.schedule_contributors.filters.projects')}
      value={selectedProjects}
      nameAttribute={'name'}
      onValueChange={() => {}}
      component={() => (
        <ProjectSelector
          alwaysOpen
          hideBorder
          multiple
          value={selectedProjects}
          onChange={onChange}
        />
      )}
    />
  )
}

export default ProjectFilter
